"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var TextButton = (0, styles_1.styled)(Button_1.default, { shouldForwardProp: (0, general_1.omitProps)('outlined') })(function (_a) {
    var theme = _a.theme, _b = _a.outlined, outlined = _b === void 0 ? false : _b, props = __rest(_a, ["theme", "outlined"]);
    return (__assign({ backgroundColor: outlined ? theme.palette.common.white : 'initial' }, (outlined && {
        border: '1px solid transparent',
        ':hover': {
            backgroundColor: theme.palette.common.white,
            borderColor: theme.palette[props.color || 'primary'].main,
        },
    })));
});
exports.default = (0, DefaultPropsHoC_1.default)(TextButton, {
    variant: 'text',
    color: 'primary',
});
